import { type Timer } from '../context/UniversalNavigationContext';
import { AWAITING_ADDRESS } from './constants/newMemberStates';

export const NEW_MEMBER_TIMER_DEPRECATION_FLAG = 'new_member_timer_deprecation';

// Milliseconds to wait for the Optimizely client before resolving the decision as off.
export const TIMER_DEPRECATION_DECISION_TIMEOUT = 5000;

// The address-capture redirect is the one timer redirect honoured while the timer is deprecated:
// it recovers a member who left checkout before giving a shipping address.
export const isAddressCaptureRedirect = (
  timer: Pick<Timer, 'newMemberState' | 'incompleteSubscriptionUuid'> | null | undefined,
) => !!timer?.incompleteSubscriptionUuid || timer?.newMemberState === AWAITING_ADDRESS;
